import { useState, useEffect, useCallback } from "react";
import { JyloDocumentResult, isJyloDocument } from "../../../platform/word/documentTools";

export type DocumentStatus = JyloDocumentResult & { checked: boolean };

export const useJyloDocument = () => {
  const [documentStatus, setDocumentStatus] = useState<DocumentStatus>({
    isJylo: false,
    checked: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  const checkDocumentStatus = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await isJyloDocument();
      const newStatus = { ...result, checked: true };
      setDocumentStatus(newStatus);
    } catch (error) {
      console.error("Error checking document status:", error);
      const errorStatus = { isJylo: false, checked: true };
      setDocumentStatus(errorStatus);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!documentStatus.checked) {
      checkDocumentStatus();
    }
  }, [documentStatus.checked, checkDocumentStatus]);

  return {
    documentStatus,
    isLoading,
    checkDocumentStatus,
  };
};
